import { useEffect } from 'react';
import { Play } from 'lucide-react';
import img1 from '../../assets/exterior/vasudharinihomes_exterior_2.png';
import img2 from '../../assets/interior/vasudharinihomes_interior_22.png';
import Heading from '../ui/Heading';
import { Link } from 'react-router-dom';

export default function VideoCardCarousel() {

     useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  const slides = [
      {
          id: 1,
          title: 'Vasudharini Nest Interior',
          link: '/interactive-walkthrough/interior',
          image: img2,
          playButton: true
        },
        {
          id: 2,
          title: 'Vasudharini Nest Exterior',
          link: '/interactive-walkthrough/exterior',
          image: img1,
          playButton: true
        },
  ];

  return (
    <div className="bg-white flex flex-col items-center justify-center p-4 md:p-8">
      <div className="w-full max-w-4xl">
        {/* Innovative minimalistic heading */}
        <div className="mb-12 relative mt-8 sm:mt-16">
          {/* <div className="h-1 w-16 bg-yellow-500 mx-auto mb-4"></div> */}
          {/* <h1 className="text-2xl md:text-3xl font-light text-center tracking-wider ">
            INTERACTIVE WALKTHROUGH
          </h1> */}
          <Heading level={2} className='text-center'>Interactive Walkthrough</Heading>
          {/* <div className="h-1 w-16 bg-yellow-500 mx-auto mt-4"></div> */}
        </div>
        
        {/* Responsive grid for all screen sizes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-10 mb-5">
          {slides.map((slide) => (
            <div key={slide.id} className="bg-gray-50 rounded-lg border overflow-hidden p-3 ">
              <div className="relative">
                <img 
                  src={slide.image} 
                  alt={slide.title} 
                  className="w-full h-48 object-cover rounded"
                />
                {slide.playButton && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Link 
                    to={slide.link}
                    >
                        <div className="bg-white rounded-full p-2 shadow-md cursor-pointer hover:bg-yellow-100 transition-colors duration-300">
                        <Play size={24} className="text-yellow-500" />
                        </div>
                    </Link>
                  </div>
                        
                )}
              </div> 
              <div className="p-4 text-center">
                <h3 className="text-lg mb-3">{slide.title}</h3>
                <Link 
                    to={slide.link}
                  className="inline-block bg-yellow-500 text-white text-sm font-bold tracking-wider py-2 px-6 rounded-full uppercase hover:bg-yellow-600 transition-colors duration-300"
                >
                  Start
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}